import { useEffect } from 'react';
import { getAuthMe } from '@/api';

/**
 * REST-based replacement for the old Supabase onAuthStateChange listener.
 * Since the REST API has no realtime session events, this just validates
 * the token stored in localStorage on mount and keeps userType in sync.
 * Login/register/logout already write directly to localStorage.
 */
export function useAuthListener() {
  useEffect(() => {
    const token = localStorage.getItem('token');
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (!token || !isLoggedIn) return;

    getAuthMe()
      .then((me: any) => {
        if (!me) {
          // Session is dead — clear it
          localStorage.removeItem('token');
          localStorage.removeItem('isLoggedIn');
          window.dispatchEvent(new Event('authStateChanged'));
          return;
        }
        const role = (me.role ?? me.userType ?? localStorage.getItem('userType') ?? 'customer').toString().toLowerCase();
        localStorage.setItem('userType', role);
        if (me.name) localStorage.setItem('userName', me.name);
        if (me.avatar || me.avatarUrl) localStorage.setItem('userAvatar', me.avatar || me.avatarUrl);
        window.dispatchEvent(new Event('authStateChanged'));
      })
      .catch(() => {
        // Network error — leave existing localStorage state untouched
      });
  }, []);
}
